export default __webpack_public_path__ + "static/media/flag-pl.3038582e.svg";